import { Ranking } from "model/Ranking";
import { Season } from "model/Season";
import * as firebaseClient from "../script/firestore-client";

const table = 'ranking'

export async function listFromCache(season: Season) {
  const ranking = await firebaseClient.listFromCache(
    table,
    [{ key: 'season.id', condition: '==', value: season.id }],
    [{ key: 'update_time', condition: 'desc' }],
    1
  ) as Ranking[]
  return ranking[0]
}